import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../providers";
import { PaymentStrings } from "../../../../business/core";
import { PaymentOrdersPageControllerImpl } from "../../../../business/impl";

interface IStrategyButtonBankSlipCancel {
    id: string;
}

export const StrategyButtonBankSlipCancel: React.FC<IStrategyButtonBankSlipCancel> = ({ id }) => {
    const { setCallbackLogin, handleLogout } = useAuth();
    const [showModal, setShowModal] = useState<boolean>(false);
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState<boolean>(false);
    const strings = PaymentStrings['PTBR'].payment_order.strategy_buttons;

    const handlerCancelBankSlip = async () => {
        setLoading(true);

        const formData = new FormData();
        formData.append("payment_order", id);

        const controller = new PaymentOrdersPageControllerImpl();
        try {
            const response = await controller.cancelBankInvoice(formData);
            localStorage.setItem('global-toast', JSON.stringify({ type: 'success', message: response.response.toString() }));
            window.location.reload();
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/adm/dashboard',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                localStorage.setItem('global-toast', JSON.stringify({ type: 'danger', message: 'Erro na requisição' }));
                window.location.reload();
                console.error("Erro na requisição:", error);
            }
        }
    }

    return (
        <>
            <Button
                size="sm"
                onClick={() => setShowModal(true)}
                variant={'danger'}
                disabled={isLoading}>
                {isLoading
                    ? <Spinner size="sm" />
                    :
                    <>
                        {strings.cancel_bank_slip_button_label}
                    </>
                }
            </Button>

            <Modal show={showModal} onHide={() => !isLoading ? setShowModal(false) : null}>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.create_bank_slip_button_label}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {strings.cancel_bank_slip_confirmation}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isLoading}>{strings.modal.button_cancel}</Button>
                    <Button variant="primary" onClick={() => handlerCancelBankSlip()} disabled={isLoading}>{strings.modal.button_forward}</Button>
                </Modal.Footer>
            </Modal ></>
    )
}